import { Component, OnInit, Renderer2 } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';

@Component({
  selector: 'app-create-success-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss']
})
export class CreateSuccessPageComponent implements OnInit {
  fullWidthView$: Observable<boolean>

  constructor(private store: Store<any>,
    private renderer: Renderer2) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  ngOnInit()
  {
    // add login class to body for background image
    this.renderer.addClass(document.body, 'login');
  }

  ngOnDestroy() {
    // remove login class
    this.renderer.removeClass(document.body, 'login');
  }

}
